import React, { ReactElement } from "react";
import { makeStyles, Button } from "@material-ui/core";
import "react-toastify/dist/ReactToastify.css";
import { CSVLink } from "react-csv";
import theme from "../../themes";
import Loader from "./Loader/Loader";
import { Data, Headers } from "react-csv/components/CommonPropTypes";
import UilExportIcon from "../../images/uil_export.png";

const useStyles = makeStyles(() => ({
  buttonContainer: {
    display: "flex",
  },
  exportButton: {
    fontFamily: "'DM Sans', sans-serif",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "150%",
    backgroundColor: "#FFFFFF",
    color: theme.palette.primary.main,
    borderRadius: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textTransform: "uppercase",
    padding: "10px 20px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "15px",
    },
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
}));

const ExportButton = ({
  loading,
  csvData,
  csvHeaders,
  label,
  icon,
  disablePadding,
  customOnClick,
}: {
  loading?: boolean;
  csvData?: string | Data | undefined | null;
  csvHeaders?: Headers | undefined;
  label: string;
  icon?: ReactElement;
  disablePadding?: boolean;
  customOnClick?: () => void;
}): ReactElement => {
  const classes = useStyles();

  return (
    <div
      className={classes.buttonContainer}
      style={{ ...(disablePadding ? { padding: 0, margin: 0 } : {}) }}
    >
      {loading ? (
        <Button
          size="large"
          variant="contained"
          className={classes.exportButton}
          disabled
        >
          <img src={UilExportIcon} alt="Export" style={{ marginRight: "10px", width: "24px", height: "24px" }} />
          <div
            style={{
              position: "relative",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {label}
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "-50%",
              }}
            >
              <Loader />
            </div>
          </div>
        </Button>
      ) : customOnClick ? (
        <Button
          size="large"
          variant="contained"
          className={classes.exportButton}
          onClick={customOnClick}
        >
          {icon ? (
            <>{icon}</>
          ) : (
            <img src={UilExportIcon} alt="Export" style={{ marginRight: "10px", width: "24px", height: "24px" }} />
          )}
          {label}
        </Button>
      ) : (
        <>
          <CSVLink
            data={csvData || []}
            headers={csvHeaders}
            style={{
              textDecoration: "none",
            }}
            filename={`${label.split(" ").join("-")}.csv`}
          >
            <Button
              size="large"
              variant="contained"
              className={classes.exportButton}
            >
              <img src={UilExportIcon} alt="Export" style={{ marginRight: "10px", width: "24px", height: "24px" }} />
              {label}
            </Button>
          </CSVLink>
        </>
      )}
    </div>
  );
};

export default ExportButton;
